/** Dispatched after a lead is updated outside list hooks (e.g. quota abandon). */
export const LEAD_UPDATED_EVENT = 'leadsme:lead-updated';
